import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loggedoutheader',
  templateUrl: './loggedoutheader.component.html',
  styleUrls: ['./loggedoutheader.component.css']
})
export class LoggedoutheaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
